const getOptionSelectPaymentStatus = (t) => [
    {
        name: t('created'),
        forBack: 'Created'
    },
    {
        name: t('completed'),
        forBack: 'Completed'
    },
    {
        name: t('rejected'),
        forBack: 'Rejected'
    },
    {
        name: t('declined'),
        forBack: 'Declined'
    },
    {
        name: t('other'),
        forBack: 'Other'
    },
]

export {
    getOptionSelectPaymentStatus
}